import { TRootState } from 'Redux/Reducers';

export const getStripeClientSecret = (state: TRootState) => state.payment.paymentIntentClientSecret;
